import React,{useState} from 'react'
import './DetailsTool.css';
import {Grid,FormControlLabel,Checkbox} from '@mui/material';

const DetailsTool = () => {

    const [windowWidth, setWindowWidth] = useState(window.outerWidth);

    window.addEventListener('resize',function (){
      setWindowWidth(window.outerWidth)
    })

    var arr = ['Pets','Swimming','Smoking','Alcohol','Kids under 12','Fishing','Glass bottles','Shoes','Liveaoard','Red wine']

  return (
    <div className='DetailsFeaturesMain'>
        <p style={{fontWeight:700,fontSize:22,textAlign:'left',marginTop:30}}>Tools</p>
        <Grid container>
            <Grid item  md={windowWidth>1070 ? 8 : 9} lg={7} xl={5.5}>
        <div className='detailsFeatureDiv'>
            <Grid container style={{paddingLeft:'10px'}}>
            {
                arr.map(v=>(
                    <Grid item md={4} sm={6} xs={windowWidth>495 ? 6 : 'auto'} style={{justifyContent:'flex-start',alignItems:'flex-start',display:'flex'}}>
                        <FormControlLabel control={<Checkbox />} label={v} />
                    </Grid>
                ))
            }
            </Grid>
        </div>
            </Grid>
        </Grid>
    </div>  )
}

export default DetailsTool

